import { CREATEHOSPITALEBIRTHRECORD, CREATEHOSPITALEDEATHRECORD, DELETEHOSPITALEBIRTHRECORD, DELETEHOSPITALEDEATHRECORD, GETHOSPITALEBIRTHRECORD, GETHOSPITALEDEATHRECORD, UPDATEHOSPITALEBIRTHRECORD, UPDATEHOSPITALEDEATHRECORD } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEHOSPITALEBIRTHRECORD:
            return {
                ...state,
                birthrecordSaveStatus: action.payload.success,
            }
        case GETHOSPITALEBIRTHRECORD:
                return {
                        ...state,
                        birthrecordList: action.payload.data,
                        }
        case UPDATEHOSPITALEBIRTHRECORD:
                return {
                        ...state,
                        birthrecordUpdateStatus: action.payload.success,
                        }   

        case DELETEHOSPITALEBIRTHRECORD:
                 return {
                     ...state,
                     birthrecordDeleteStatus: action.payload.success,
                        } 
        case CREATEHOSPITALEDEATHRECORD:
            return {
                ...state,
                deathrecordSaveStatus: action.payload.success,
            }
        case GETHOSPITALEDEATHRECORD:
                return {
                        ...state,
                        deathrecordList: action.payload.data,
                        }
        case UPDATEHOSPITALEDEATHRECORD:
                return {
                        ...state,
                        deathrecordUpdateStatus: action.payload.success,
                        }   

        case DELETEHOSPITALEDEATHRECORD:
                 return {
                     ...state,
                     deathrecordDeleteStatus: action.payload.success,
                        } 
                        default:
                            return state
                             }
                         }